import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { FormInput } from 'pages/checkout/components/common/input-styled-components';

interface SuccessProps {
  $isSuccess?: boolean;
}

export const Wrapper = styled.form<SuccessProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;

  border-radius: 80px;
  background-color: ${BRAND_COLORS.dirtyWhite};

  transition: background-color 0.2s ease-in-out;

  ${({ $isSuccess }) => !$isSuccess && css`
    cursor: pointer;
    &:hover {
      background-color: ${BRAND_COLORS.lightGray};
    }
  `}
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const inputTypography = css`
  ${TYPOGRAPHY.CIRCULAR.book}
  font-size: 14px;
  line-height: 21px;
  color: ${BRAND_COLORS.darkGray};
`;

export const TransparentFormInput = styled(FormInput)`
  ${inputTypography}
  background-color: transparent;
  border: none;
  width: 100%;
  padding: 0;
  height: auto;
  border-radius: 0;

  &::placeholder {
    ${inputTypography}
    color: ${BRAND_COLORS.darkStroke};
  }

  &:focus-visible {
    outline: none;
  }
`;

export const SuccessInput = styled.p`
  ${inputTypography}
`;

export const SubmitButton = styled.button.attrs({ type: 'submit' })<{ $loading?: boolean; }>`
  border: none;
  background: 0;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $loading }) => $loading && css`
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;
